import { render, staticRenderFns } from "./HeadingComponent.vue?vue&type=template&id=3f6e963a"
import script from "./HeadingComponent.vue?vue&type=script&lang=js"
export * from "./HeadingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports